import tpl from 'Templates/bits/dropdown.html'

angular
	.module('P3in')
	.directive('dropDown', DropDown)
	
DropDown.$inject = ['$filter']

function DropDown ($filter) {
	return {
		restrict: 'EA',
		template: tpl,
		scope: {
			content: '=dropDown',
			key: '=',
			value: '='
		},
		controllerAs: 'DropDownCtrl',
		require: '?ngModel',
		replace: true,
		link: function(scope, element, attrs, ngModel) {
			if (!ngModel) return;

			scope.$watch(function() {
				return ngModel.$modelValue
			}, function(nv, ov) {
				scope.select(nv)
			})

			element.bind('click', function() {
				element.addClass('show');
			})

			element.bind('mouseleave', function() {
				element.removeClass('show')
			})

			scope.select = function(item) {
				ngModel.$setViewValue(item)
				let count = 0
				_.forEach(scope.content, function(single) {
					if (single.key == item)
						scope.selected = scope.content[count];
					count++;
				})
			}
			
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/modules/P3in/directives/drop-down.js